import { createHashRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home";
import Courses from "./components/Courses";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";
import RefundPolicy from "./components/RefundPolicy";
import PaymentPolicy from "./components/PaymentPolicy";
import Disclaimer from "./components/Disclaimer";

import RemedialEducation from "./components/RemedialEducation";

const router = createHashRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "courses", element: <Courses /> },
      { path: "about", element: <AboutUs /> },
      { path: "contact", element: <Contact /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "terms-conditions", element: <TermsConditions /> },
      { path: "refund-policy", element: <RefundPolicy /> },
      { path: "payment-policy", element: <PaymentPolicy /> },
      { path: "disclaimer", element: <Disclaimer /> },
      { path: "remedial-education", element: <RemedialEducation /> },
    ],
  },
]);

export default router;
